/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ServicesInputs */

const en_footer_services = /** @type {(inputs: Footer_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions`)
};

const pl_footer_services = /** @type {(inputs: Footer_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajęcia`)
};

/**
* | output |
* | --- |
* | "Sessions" |
*
* @param {Footer_ServicesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_services = /** @type {((inputs?: Footer_ServicesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ServicesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_footer_services(inputs)
	return en_footer_services(inputs)
});